export const SHOP = 'shop';
export const DOOR = 'door';
